import styled from "styled-components";

export const StyledSystemCommandWrapper = styled.div`

`;

export const StyledAbstractCommandWrapper = styled.div`
  max-width: 500px;
  width: 100%;
  margin-right: 20px;
  margin-bottom: 20px;
  padding: 25px;
  display: inline-flex;
  flex-direction: column;
  background-color: rgba(245,244,250,0.25);
  box-shadow: 0 2px 4px #c4c4c4;
  border-radius: 16px;
  transition: all .15s ease .15s;
  .command__description {
    padding-bottom: 20px;
    color: #162954;
    font-size: 18px;
    font-weight: 600;
  }
`;